import { CLEAR_INSTANCES, UPDATE_INSTANCES, SET_INSTANCE } from "../reducers/actiontypes";

const initialState = (function(state={}) {
	state.data = state.data || [];
	state.current = state.current || "default";
	return state;
})(window.commentstate.instances);

export default function(state=initialState, action) {
	switch (action.type) {
		case CLEAR_INSTANCES:
			return { ...state, data: [] };
		case UPDATE_INSTANCES:
			return { ...state, data: action.instances };
		case SET_INSTANCE:
			return { ...state, current: action.instance };
		default:
			return state;
	}
}